import { Button, Dialog, DialogContent, Grid, IconButton, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import CloseIcon from "@mui/icons-material/Close";
import icon_noid from "../../../../../Image/icon_noid.png";
interface IDataDialogNoInformationFound {
    setOpenErrorDialog: (open: boolean) => void;
    openErrorDialog: boolean;
    errorTextStatus?: any;
    errorTextStatus2?: any;
}


const DialogNoInformationFound: React.FC<IDataDialogNoInformationFound> = ({ setOpenErrorDialog, openErrorDialog, errorTextStatus, errorTextStatus2 }) => {

    const handleCloseErrorDialog = () => {
        setOpenErrorDialog(false);

    };
    // console.log('errorTextStatus?.message :>> ', errorTextStatus?.message);

    const getErrorMessage = () => {
        if (errorTextStatus?.message === 'CID priotiry 4 invalid') {
            return 'ข้อมูล สสจ ไม่สามารถตรงกับผู้อนุมัติเอกสารลำดับอื่นได้ กรุณาเปลี่ยนแปลงข้อมูล สสจ ที่มีสิทธิ์ลงนามเอกสาร';
        } else if (errorTextStatus?.message === 'CID priotiry 2 invalid') {
            return 'เลขประจำตัวประชาชนของพยานไม่สามารถตรงกับผู้ขอเอกสารได้ กรุณาเปลี่ยนแปลงพยาน';
        } else {
            return 'ไม่พบข้อมูล Provider ID / Health ID ของพยาน';
        }
    };

    return (
        <div>
            <Dialog
                open={openErrorDialog}
                //  open={openErrorDialog}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                        handleCloseErrorDialog();
                    }
                }}
                fullWidth
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        bgcolor: "#FFFFFF",
                        borderRadius: "20px",
                        boxShadow: 3,
                        // p: 2,
                        width: "470px",
                    },
                }}
            >
                <IconButton
                    onClick={() => setOpenErrorDialog(false)}
                    sx={{ position: "absolute", top: 8, right: 8 }}
                >
                    <CloseIcon />
                </IconButton>

                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        justifyContent="center"
                        alignItems="center"
                    >
                        <Grid item xs={12} display="flex" justifyContent="center" sx={{ mt: 3 }}>
                            <img
                                src={icon_noid}
                                alt="รูปภาพ"
                                style={{
                                    width: 180,
                                    height: "auto",
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    color: "#333333",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                }}
                            >
                                {/* {errorTextStatus?.message === 'CID priotiry 2 invalid' ? 'เลขประจำตัวประชาชนของพยานไม่สามารถตรงกับผู้ขอเอกสารได้ กรุณาเปลี่ยนแปลงพยาน' : 'ไม่พบข้อมูล Provider ID / Health ID ของพยาน'} */}


                                {getErrorMessage()}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography
                                sx={{
                                    mt: -1,
                                    textAlign: "center",
                                    color: "#636363",
                                    fontSize: "15px",
                                }}
                            >
                                {(
                                    errorTextStatus?.message === 'CID priotiry 2 invalid' ||
                                    errorTextStatus?.message === 'CID priotiry 4 invalid'
                                ) ? '' : 'กรุณาระบุพยาน (อนุมัติลำดับที่ 2) อีกครั้ง'}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container justifyContent={'center'} display={'flex'} mt={3}>
                        <Button
                            onClick={handleCloseErrorDialog}
                            variant='contained'
                            sx={{ backgroundColor: '#0288D1', borderRadius: 20, width: 120 }}>ตกลง</Button>
                    </Grid>

                </DialogContent>
            </Dialog>
        </div>
    )
}

export default DialogNoInformationFound;
